export const menuList = [
  // {
  //   title: '个人中心',
  //   justShow: true
  // },
  {
    key: 'index',
    path: '/personalCenter/index',
    title: '我的订单'
  },
  {
    key: 'address',
    path: '/personalCenter/address',
    title: '收货地址'
  },
  {
    key: 'invoice',
    path: '/personalCenter/invoice',
    title: '开票信息'
  },
  {
    key: 'qualification',
    path: '/personalCenter/qualification',
    title: '我的资质'
  }
  // {
  //   key: 'password',
  //   path: '/personalCenter/password',
  //   title: '密码修改'
  // },
  // {
  //   key: 'phone',
  //   path: '/personalCenter/phone',
  //   title: '修改手机号'
  // },
  // {
  //   title: '我的财富',
  //   justShow: true
  // },
  // {
  //   key: 'coupon',
  //   path: '/personalCenter/coupon',
  //   title: '我的优惠券'
  // }
  // {
  //   title: '设置',
  //   justShow: true
  // },
  // {
  //   key: 'agreement',
  //   path: '/personalCenter/agreement',
  //   title: '资质与协议'
  // }
];
